const CLEVER_LOGIN_URLS: Record<string, string> = {
  production: 'https://login.listwithclever.com/',
  staging: 'https://login-staging.listwithclever.com/',
};

const LOCAL_CLEVER_LOGIN_URL = 'http://localhost:3001/';

export const getLoginUrl = (returnUrl: string): string => {
  const loginUrl =
    CLEVER_LOGIN_URLS[process.env.GATSBY_ACTIVE_ENV || ''] || LOCAL_CLEVER_LOGIN_URL;
  return `${loginUrl}?redirectUrl=${encodeURIComponent(returnUrl)}`;
};

export const hasMagicLinkInUrl = (): boolean =>
  typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('magic_uuid');

export const isInsideFrame = (): boolean => window.self !== window.top;

type SignInState = {
  isAuthenticated: boolean;
  authLoading: boolean;
  magicLinkLoading: boolean;
  magicLinkFailed: boolean;
  hasMagicLink: boolean;
};

export const shouldPromptSignIn = ({
  isAuthenticated,
  authLoading,
  magicLinkLoading,
  magicLinkFailed,
  hasMagicLink,
}: SignInState): boolean => {
  if (isAuthenticated || authLoading || magicLinkLoading) {
    return false;
  }
  return !hasMagicLink || magicLinkFailed;
};
